import * as React from "react";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import Modal from "../../misc/components/modal";
import { MultiSelect } from "../../forms/informedv4/MultiSelectV4";
import { Query, Report } from "../../misc/api/apiTypes";
import { Form, useFormApi } from "informedv4";
import LoadingWithMessage from "../../misc/components/LoadingWithMessage";
import { Role } from "webportalclient";

export interface ImportPermissionsProps {
    roleId: string;
    onClose: () => void;
}

export const ReportsPermissions = ({ roleId, onClose }: ImportPermissionsProps) => {
    const [reports, setReports] = React.useState<Report[]>();
    const legacyClient = useWebPortalLegacyClient();
    const client = useWebPortalApiClient();
    const [roleReports, setRoleReports] = React.useState<Report[]>();
    const [selectedRole, setSelectedRole] = React.useState<Role>()

    React.useEffect(() => {
        loadData();
    }, [roleId])


    const loadData = async () => {
        const initialQuery: Query<Report> = {};
        var reportsQuery = await legacyClient.getReports(initialQuery);
        var reports = reportsQuery.Data ? reportsQuery.Data : [];
        var role = await client.client.getRole(roleId);
        var rolesReports = role.reports?.length > 0 ? reports.filter(e => role.reports.includes(e.Id)) : [];
        setRoleReports(rolesReports);
        setSelectedRole(role);
        setReports(reports);
    }

    return (
        <Form initialValues={{ Reports: roleReports }}>
            <AReportsPermissionsForm reports={reports} selectedRole={selectedRole} onClose={onClose} roleId={roleId} />
        </Form>
    );
}


interface AReportsPermissionsFormState {
    Reports: Report[]
}

interface AReportsPermissionsProps {
    roleId: string
    reports: Report[]
    selectedRole: Role;
    onClose: () => void;
}

export const AReportsPermissionsForm = ({ roleId, reports, selectedRole, onClose }: AReportsPermissionsProps) => {
    const client = useWebPortalApiClient();
    const [error, setError] = React.useState<string | undefined>();

    const formApi = useFormApi();

    const onSaveClick = async () => {
        try {
            var selectedReports = formApi.getFormState().values.Reports ?? [];
            selectedRole.reports = (selectedReports as Report[]).map(e => e.Id);
            await client.client.patchRole(selectedRole, selectedRole.id);
            onClose();
        } catch (ex) {
            setError(ex.Message);
        }
    }

    if (!reports)
        return (
            <Modal show={true} header="Reports Permissions to Role">
                <div className="modal-body">
                    <LoadingWithMessage message="Loading Reports..." />
                </div>
            </Modal>
        )

    return (
        <Modal show={true} header="Reports Permissions to Role">
        <div className="modal-body">
            <div className="row">
                <div className="col-md-12">
                    <div className="panel-body">
                        {error ? <Alert show={true} category={AlertCategoryEnum.Danger}>{error}</Alert> : null}
                        <div className="form-group col-sm-12 col-xs-12">
                            <label htmlFor="name">Permitted Reports</label>
                            <MultiSelect id="Reports" name="Reports" field="Reports" multi={true} options={reports} labelKey="Name" valueKey="Id" />
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="modal-footer">
                <button id="importButton" className="btn btn-primary" type="button" disabled={false} onClick={onSaveClick}>
                    Permit
                </button> &nbsp;
                <button id="returnToListButton" className="btn btn-primary btn-outline" onClick={onClose}>
                    Return to List
                </button>
            </div>
        </Modal>
    );
}
